import { Intersection } from 'three/src/core/Raycaster';
import { Event, Line3, Object3D, Vector3 } from 'three';
import { itemDataApi } from '@/Interfaces/api';
import { getModulesIntersections } from '@/Engine/intersections';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { sides, storeConfigurationState } from '@/Interfaces/common';
import { transformPositionBySide } from '@/lib/transformPositionBySide';
import { $ } from '@/Engine/state';
import { tempDoorDataTemplate, tempWindowDataTemplate } from '@/Constants/demo';
import { addDoor, addWindow } from '@/Engine/addDoorAndWindow';
import { getShelfSet } from '@/lib/createModule';
import { selectObject } from '@/Engine/eventHandlers/onClickSelection';
import { requestJson } from '@/utils/httpRequest';
import { useStoreData } from '@/Store/storeData';
import { updatePresetData } from '@/lib/updatePresetData';
import { replaceItemsKitColor } from '@/lib/replaceItemsKitColor';

export const onWallIntersection = async(wallIntersections: Intersection<Object3D<Event>>, data: { data: itemDataApi; category: any; }) => {
    const modulesIntersection = getModulesIntersections();
    const parentModule = modulesIntersection[0]?.object.userData.parent as RackModule;
    const moduleIntersectionPoint = modulesIntersection[0]?.point;
    const side = wallIntersections.object.name as sides;
    const position = transformPositionBySide(
        wallIntersections.point,
        side,
        $.room,
    );

    if (data.data.name === 'Окно') {
        $.tempWindowData = { ...tempWindowDataTemplate, side, position };
        const window = addWindow($.tempWindowData);
        if ($.checkCollision(window, side)) {
            window.model.removeFromParent();
        }
        return;
    }

    if (data.data.name === 'Дверь') {
        $.tempDoorData = { ...tempDoorDataTemplate, side, position };
        const door = addDoor($.tempDoorData);
        if ($.checkCollision(door, side)) {
            door.model.removeFromParent();
        }
        return;
    }

    if (data.data.name === 'Куб') {
            return;
    }
    //TODO TODO
    if (data.data.url?.endsWith('json')) {
        // $.tempKit = await requestJson(data.data.url as string) as storeConfigurationState;
        const url = data.data.url;
        useStoreData().resetDnDElement();
        window.console.log('requesting url ', url);
        const kit = await requestJson(url as string) as storeConfigurationState;
        updatePresetData(kit.wardrobe);
        replaceItemsKitColor(kit.wardrobe, $.wardrobe.baseColor);
        $.wardrobe.add(kit.wardrobe);
        $.dragging = true;
        $.selection = true;
        const lastRackModule = $.wardrobe.rackModules[$.wardrobe.rackModules.length-1];
        selectObject(lastRackModule);
        const line = new Line3(lastRackModule.position, new Vector3(...position));
        $.selectionBox.setGroupPositionDelta(line);


        // $.updated = true;
        // onTempItems();
        return;
    }
    // $.tempModule = createModule({
    //     position: position,
    //     uuid: 'temp',
    //     side: wallIntersections.object.name as sides,
    //     data: data.data,
    //     category: data.category,
    // });
    // $.wardrobe.addModule($.tempModule, side);
    // const newModule = $.wardrobe.getModuleByUUID('temp');
    // if (!newModule) return;


    if (!$.tempShelf) {
        $.tempShelf = getShelfSet(data.data, crypto.randomUUID());
    }
    $.tempShelf.position = position;
    $.tempShelf.side = side;

    const shelf = $.wardrobe.addShelf($.tempShelf);

    if (shelf) {
        let rackModule;
        if (!$.tempShelf.rackModuleUUID)
            [ $.tempModule, rackModule ] = $.wardrobe.addModuleForShelf($.tempShelf, [], shelf);
        if ($.tempModule && !$.tempShelf.railGroupUUID && rackModule) {
            $.tempRail = $.wardrobe.addRailForRack($.tempModule, [], rackModule);
        }
        $.dragging = true;
        $.selection = true;
        selectObject(shelf);
    }
};
